import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { countDecimals, countNumberOfDigits } from '@shared';
import { ValidationKeys } from '../models';
import { cleanControlValidations } from './clean-control-validations';

export const checkDecimalPlaces =
	(decimalPlaces: number): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const forbidden = countDecimals(control.value) > decimalPlaces;
		return forbidden ? { [ValidationKeys.validationTypes.decimalPlaces]: { value: control.value } } : null;
	};

export const checkNumberOfDigits =
	(numerOfDigits: number): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const forbidden = countNumberOfDigits(control.value) > numerOfDigits;
		return forbidden ? { [ValidationKeys.validationTypes.maximumLength]: { value: control.value } } : null;
	};

export const checkSpecialChars =
	(condition: RegExp, validationType: string): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const forbidden = control.value && !condition.test(control.value);
		return forbidden ? { [validationType]: true } : null;
	};

export const fromToValidator =
	(crossControlKey: string, validationAgainstField: string, validationAgainstCrossField: string): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const group = control.parent;

		let formattedControlDate: Date;
		let formattedCrossControlDate: Date;
		let formattedControlTime: number;
		let formattedCrossControlTime: number;

		let errorFlag = false;
		let validationError: ValidationErrors;

		if (group?.controls[crossControlKey]?.value) {
			if (group?.controls[crossControlKey].errors) {
				cleanControlValidations(group, crossControlKey, [
					validationAgainstField,
					validationAgainstCrossField,
					ValidationKeys.validationRules.intervalBreachRule,
					ValidationKeys.validationRules.intervalOverlapRule,
					ValidationKeys.validationRules.intervalDupRule,
					ValidationKeys.validationRules.intervalGapRule,
					ValidationKeys.validationRules.preventIntervalCorruptionRule,
					ValidationKeys.validationRules.startAtZeroRule
				]);
			}

			if (control.value) {
				validationError = { [validationAgainstCrossField]: group?.controls[crossControlKey].value };

				switch (crossControlKey) {
					case WorkspaceDatabaseKeys.columns.depthFrom:
						errorFlag =
							Number(control.value) <= Number(group?.controls[crossControlKey].value) ? true : false;
						break;
					case WorkspaceDatabaseKeys.columns.depthTo:
						errorFlag =
							Number(control.value) >= Number(group?.controls[crossControlKey].value) ? true : false;
						break;
					case WorkspaceDatabaseKeys.columns.startDate:
						formattedControlDate = new Date(control.value);
						formattedControlTime = formattedControlDate.getTime();
						formattedCrossControlDate = new Date(group?.controls[crossControlKey].value);
						formattedCrossControlTime = formattedCrossControlDate.getTime();

						errorFlag =
							formattedControlDate < formattedCrossControlDate ||
							formattedControlTime === formattedCrossControlTime
								? true
								: false;
						break;
					case WorkspaceDatabaseKeys.columns.completedDate:
						formattedControlDate = new Date(control.value);
						formattedControlTime = formattedControlDate.getTime();
						formattedCrossControlDate = new Date(group?.controls[crossControlKey].value);
						formattedCrossControlTime = formattedCrossControlDate.getTime();

						errorFlag =
							formattedControlDate > formattedCrossControlDate ||
							formattedControlTime === formattedCrossControlTime
								? true
								: false;
						break;
				}
			}
		}
		return errorFlag ? validationError : null;
	};
